module.exports = __webpack_public_path__ + "static/media/bstn-3.8b96c04f.jpg";